import React from "react";
import { t } from "../data/locale";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-6 col-md-offset-3 text-center">
            <div className="section-title">
              <h2>{t("contactTitle")}</h2>
            </div>
            <div className="contact-item">
              <span>
                <i className="fa fa-envelope-o"></i> {t("contactEmailLabel")}
              </span>
              <p>{props.data ? props.data.email : "loading"}</p>
            </div>
            <div className="contact-item">
              <span>
                <i className="fa fa-wechat"></i> {t("contactWechatLabel")}
              </span>
              <p>selenenext</p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>{t("footer")}</p>
        </div>
      </div>
    </div>
  );
};
